import React, { useState } from 'react'
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Rating } from 'primereact/rating';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

export default function P222List({dataTable}) {

    // const [layout, setLayout] = useState();
    // const [sortOrder, setSortOrder] = useState(null);
    // const [sortField, setSortField] = useState(null);

    const itemTemplate = (data) => {
        if (!data) {
            return;
        }
        return dataviewListItem(data);
      
    };

    const dataviewListItem = (data) => {
        return (
            <div className="p-col-12">
                <div className="product-list-item">
                <hr/>
                    {/* <div className="product-list-detail"> */}
                        <div className="p-grid p-fluid" style={{ marginTop: "20px" }}>
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="inspectTime">ครั้งที่</label>
                                <InputText
                                    type="text"
                                    placeholder="ครั้งที่"
                                    value={data.warningNo}
                                    disabled 
                                />
                            </div>

                            <div className="p-col-12 p-md-3">
                                <label htmlFor="inspectTime">วันที่แจ้ง</label>
                                <InputText
                                    type="text"
                                    placeholder="วันที่แจ้ง"
                                    value={data.warningDateForDisplay}
                                    disabled 
                                />
                            </div>

                            <div className="p-col-12 p-md-3">
                                <label htmlFor="inspectTime">เลขที่หนังสือ</label>
                                <InputText
                                    type="text"
                                    placeholder="เลขที่หนังสือ"
                                    value={data.warningLetterNo}
                                    disabled   
                                />
                            </div>
                            
                            <div className="p-col-12 p-md-2">
                                <Button
                                    className="p-button p-button-warning btn-srh-responsive"
                                    icon="fas fa-file-alt"
                                    label="ไฟล์แนบ"
                                    style={{ display: 'flex',marginBottom : '10px',marginTop: 15 }}
                                    disabled ={!data.attachmentPathName || data.attachmentPathName === '' || data.attachmentPathName || null}
                                    // onClick={() => {setDialogAlert({dialog:true}) }}
                                    //222 
                                />
                            </div>
                        </div>
                                        
                        <div className="p-grid p-fluid" >
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="inspectTime">เรื่อง</label>
                                <InputText
                                    type="text"
                                    placeholder="เรื่อง"
                                    value={data.warningTopic}
                                    disabled 
                                />
                            </div>
                            
                            <div className="p-col-12 p-md-3">
                                <label htmlFor="inspectTime">ผู้แจ้ง</label>
                                <InputText
                                    type="text"
                                    placeholder="ผู้แจ้ง"
                                    value={data.issuerName}
                                    disabled   
                                />
                            </div>

                            <div className="p-col-12 p-md-6">
                                <label htmlFor="inspectTime">หมายเหตุ</label>
                                <InputText
                                    type="text"
                                    placeholder="วันที่แจ้ง"
                                    value={data.contractorName}
                                    disabled   
                                />
                            </div>
                        </div>
                        
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-6"></div>
                            
                        </div>

                    {/* </div> */}
                </div>
            </div>
        );
    };

//     attachmentPathName: null
    return (
        <div>
            <DataView 
                value={dataTable} 
                paginator rows={5} 
                itemTemplate={itemTemplate} 
            ></DataView>
        </div>
    )
}
